import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { UPDATE_MODEL_EVENT } from '@sgui-plus/utils/constants'
import { modalContentProps } from './modal-content'

import type { AppContext, ExtractPropTypes, VNode } from 'vue'

// type DoneFn = (cancel?: boolean) => void
// export type ModalBeforeCloseFn = (done: DoneFn) => void

export const modalProps = buildProps({
  ...modalContentProps,
  id: {
    type: String,
    default: '',
  },
  transfer: {
    type: Boolean,
    default: true
  },
  beforeCancel: {
    type: definePropType<() => boolean>(Function),
  },
  destroyOnClose: {
    type: Boolean,
    default: false
  },
  closeOnPressEscape: {
    type: Boolean,
    default: true
  },
  lockScroll: {
    type: Boolean,
    default: true
  },
  mask: {
    type: Boolean,
    default: true
  },
  maskClass: String,
  openDelay: {
    type: Number,
    default: 0
  },
  closeDelay: {
    type: Number,
    default: 0
  },
  top: {
    type: String
  },
  left: {
    type: [String, Number]
  },
  modelValue: {
    type: Boolean,
    default: false
  },
  width: {
    type: [String, Number]
  },
  height: {
    type: [String, Number]
  },
  zIndex: {
    type: Number
  }
} as const)

export type ModalProps = ExtractPropTypes<typeof modalProps>

export interface ModalFnProps extends Partial<ModalProps> {
  content?: string | VNode
  appContext?: AppContext | null
  onOk?: (...args: any[]) => any
  onCancel?: (...args: any[]) => any
  onOpen?: () => void
  onHidden?: () => void
}

export const modalEmits = {
  open: () => true,
  hidden: () => true,
  ok: () => true,
  cancel: () => true,
  [UPDATE_MODEL_EVENT]: (value: boolean) => typeof value === 'boolean',
  dragStart: () => true,
  dragEnd: () => true,
  maximize: (value: boolean) => typeof value === 'boolean',
  minimize: (value: boolean) => typeof value === 'boolean',
  fullscreen: (value: boolean) => typeof value === 'boolean'
}
export type ModalEmits = typeof modalEmits

export type ModalParams = ModalFnProps | string | VNode
export type ModalFn = ((options?: ModalParams) => Promise<any>)

export interface IModal extends ModalFn {
  readonly confirm: ModalFn
  readonly info: ModalFn
  readonly success: ModalFn
  readonly warning: ModalFn
  readonly error: ModalFn
  readonly alert: ModalFn,
  readonly show: ModalFn,
  readonly remove: (id: string) => void
}
